import { render, staticRenderFns } from "./ShrinkIcon.vue?vue&type=template&id=96d50354&scoped=true&"
import script from "./ShrinkIcon.vue?vue&type=script&lang=js&"
export * from "./ShrinkIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShrinkIcon.vue?vue&type=style&index=0&id=96d50354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d50354",
  null
  
)

export default component.exports